import { baseApi } from "../redux/baseAPI";

export const AppApi = baseApi.injectEndpoints({
  tagTypes: [],
  endpoints: (builder) => ({
    broadcastLocationMessage: builder.mutation({
      query: (body) => {
        return {
          url: `/nursing_home_chats/broadcast_message.json`,
          method: "POST",
          data: body,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});

export const {
  useBroadcastLocationMessageMutation,
} = AppApi;
